import { type ClickInputProps } from "./ClickInput.types";
import ClickPopulateInput from "./ClickPopulateInput";
import ClickPopulateSelect from "./ClickPopulateSelect";

const ClickInput = (props: ClickInputProps) => {
  const yachtdata = JSON.parse(localStorage.getItem("yachtData") ?? "");
  const yachtValue = yachtdata?.gmdss
    ? (yachtdata.gmdss[props.unit] ?? "")
    : "";
  const getNumberOfElementsInSection = (section: string) => {
    let count = 0;
    Object.keys(yachtdata.gmdss).forEach(key => {
      if (key.includes(section) && yachtdata.gmdss[key]) {
        count++;
      }
    });
    return count;
  };
  if (
    yachtValue &&
    ["batser1", "batexp1", "batser2", "batexp2", "batser3", "batexp3"].includes(
      props.unit,
    ) &&
    Object.keys(yachtdata.gmdss).includes(props.unit) &&
    getNumberOfElementsInSection(props.unit) > 1
  ) {
    return <ClickPopulateSelect {...props} />;
  }
  return <ClickPopulateInput {...props} />;
};

export default ClickInput;
